{
  "game.title": "Das Geheimnis des Bermuda-Dreiecks",
  "boot.milestone": "M0 — Fundament steht",
  "common.ok": "In Ordnung",
  "common.cancel": "Abbrechen",
  "common.back": "Zurück",
  "common.continue": "Weiter",
  "common.seed": "Seed: {seed}",
  "outcome.rescue": "Rettung",
  "outcome.salvage": "Bergung",
  "outcome.cold": "Kalte Spur",
  "outcome.nothing": "Nichts mehr zu finden",
  "outcome.rescue.summary": "Ihr erreicht {noun:life_raft|art=def|case=acc} rechtzeitig. {count, plural, one {Ein Mensch überlebt} other {# Menschen überleben}}.",
  "outcome.salvage.summary": "Für die Besatzung kommt ihr zu spät. Immerhin birgt ihr {noun:hull_fragment|art=indef|case=acc}.",
  "outcome.cold.summary": "{noun:wreck|art=def|case=dat|prep=von|caps} ist kaum etwas übrig — nur {noun:debris_field|art=indef|case=nom} treibt hier noch.",
  "outcome.nothing.summary": "Die See ist leer. Kein Öl, keine Trümmer, nichts.",
  "clue.found": "Ihr birgt {noun:clue|art=def|case=acc}.",
  "clue.found.count": "{count, plural, =0 {Kein Hinweis} one {# Hinweis} other {# Hinweise}} gesichert.",
  "clue.ledger.title": "Beweislage",
  "mission.distress.received": "{noun:distress_call|art=indef|case=nom|caps} von {vessel}.",
  "mission.eta": "Geschätzte Ankunft in {hours} Stunden.",
  "mission.depth": "Tiefe unter dem Kiel: {meters} Meter.",
  "voyage.fuel": "Treibstoff",
  "voyage.hull": "Rumpfzustand",
  "voyage.speed": "Fahrt: {knots} Knoten",
  "voyage.weather.calm": "Ruhige See.",
  "voyage.weather.rough": "Schwere See. {noun:storm|art=indef|case=nom} zieht auf.",
  "background.pilot": "Militärpilot",
  "background.naval_officer": "Marineoffizier",
  "background.marine_biologist": "Meeresbiologin oder Meeresbiologe",
  "accusation.prompt": "Was steckt dahinter?",
  "accusation.confidence": "Belegt durch {count, plural, one {# Fundstück} other {# Fundstücke}}.",
  "preload.loading": "Seekarte wird geladen …",
  "preload.failed": "Die Seekarte lässt sich nicht laden.",
  "place.base": "Station Thalassa",
  "place.trench": "Milwaukee-Tief",
  "place.tongue": "Tongue of the Ocean",
  "place.sargasso": "Sargassosee",
  "place.seamount": "Bermuda-Seeberg",
  "base.title": "Station Thalassa",
  "base.subtitle": "Nordkante des Northwest Providence Channel · 26°10.2'N 077°36.0'W",
  "base.standby": "Die Funkanlage schweigt. Noch.",
  "base.depart": "Auslaufen",
  "map.return": "Zur Station",
  "map.hint": "Klicken setzt einen Kurs.",
  "map.hud.position": "Position",
  "map.hud.depth": "Tiefe unter Kiel",
  "map.hud.depth.aground": "auf Grund",
  "map.hud.speed": "Fahrt",
  "map.hud.nearest": "Nächster Punkt",
  "map.hud.remaining": "Reststrecke",
  "map.hud.sea": "See",
  "map.hud.zoom": "Ansicht",
  "map.hud.knots": "{knots} kn",
  "map.hud.metres": "{metres} m",
  "map.hud.distance": "{miles} sm",
  "map.zoom.strategic": "Übersicht",
  "map.zoom.transit": "Transit",
  "map.zoom.tactical": "Nahbereich",
  "vessel.ship": "Forschungsschiff Thalassa",
  "vessel.submarine": "Tauchboot Nyx",
  "incident.cargo_vessel": "Frachtschiff",
  "incident.fishing_boat": "Fischereifahrzeug",
  "incident.private_yacht": "Segelyacht",
  "incident.airliner": "Verkehrsflugzeug",
  "incident.light_aircraft": "Sportflugzeug",
  "incident.naval_patrol": "Küstenwachboot",
  "weather.calm": "Ruhige See",
  "weather.moderate": "Mäßige See",
  "weather.rough": "Bewegte See",
  "weather.heavy": "Schwere See",
  "weather.storm": "Sturm",
  "base.calls.none": "Keine offenen Notrufe. Die See schweigt.",
  "base.calls.title": "Offene Notrufe",
  "base.clock": "Tag {day}, {hour}:00",
  "base.reputation": "Ansehen: {value}",
  "base.act": "Akt {act}",
  "base.evidence": "Beweislage ({count})",
  "base.wait": "Warten (12 h)",
  "base.finale": "Bericht abschließen",
  "base.progress": "{collected} von {total} Hinweisen",
  "call.age": "vor {hours} h",
  "call.distance": "{miles} sm",
  "call.souls": "{count, plural, one {# Person} other {# Personen}} an Bord",
  "call.depth": "Grund bei {metres} m",
  "briefing.title": "Einsatzplanung",
  "briefing.vessel": "Fahrzeug",
  "briefing.speed": "Fahrtstufe",
  "briefing.speed.slow": "Langsame Fahrt",
  "briefing.speed.cruise": "Marschfahrt",
  "briefing.speed.full": "Volle Fahrt",
  "briefing.eta": "Ankunft in {hours} h",
  "briefing.fuel": "Treibstoff {used} von {available}",
  "briefing.hull": "Rumpfschaden {value} %",
  "briefing.sea": "Schwerste See unterwegs: {sea}",
  "briefing.forecast": "Erwartung bei Ankunft",
  "briefing.fuel.short": "Der Treibstoff reicht nicht für die Rückfahrt.",
  "briefing.depth.warning": "Der Grund liegt tiefer, als dieses Fahrzeug arbeiten kann.",
  "briefing.depth.short": "zu tief",
  "briefing.shallow.warning": "Der direkte Kurs führt über eine Bank mit nur {metres} m Wasser.",
  "briefing.landfall.warning": "Der direkte Kurs führt über Land. Es wird ein Umweg nötig sein.",
  "briefing.depart": "Ablegen",
  "briefing.cancel": "Zurück",
  "site.title": "Am Einsatzort",
  "site.arrived": "Angekommen nach {hours} Stunden.",
  "site.rescued": "{count, plural, one {# Überlebende geborgen} other {# Überlebende geborgen}}.",
  "site.lost": "{count, plural, one {# Person} other {# Personen}} nicht gefunden.",
  "site.evidence.title": "Gesichert",
  "site.evidence.none": "Nichts, was sich sichern ließe.",
  "site.depth.blocked": "Das Wrack liegt zu tief. Vom Sonar bleibt nur ein Schatten.",
  "evidence.title": "Beweislage",
  "evidence.empty": "Noch nichts gesichert.",
  "evidence.act": "Akt {act}",
  "evidence.from": "aus: {source}",
  "evidence.close": "Schließen",
  "evidence.outstanding": "In diesem Akt fehlt noch",
  "evidence.hint": "Die Station wertet nicht aus. Das bleibt Ihnen überlassen.",
  "slot.witness_testimony": "Zeugenaussage",
  "slot.instrument_reading": "Instrumentenanzeige",
  "slot.anomaly_signature": "Anomalie",
  "slot.physical_artifact": "Fundstück",
  "slot.missing_person_trace": "Spur der Vermissten",
  "slot.third_party_interference": "Fremde Anwesenheit",
  "finale.title": "Abschlussbericht",
  "finale.prompt": "Was steckt hinter dem Verschwinden im Bermuda-Dreieck?",
  "finale.submit": "Diese These vertreten",
  "finale.correct": "Sie hatten recht.",
  "finale.wrong": "Die Wahrheit war eine andere.",
  "finale.truth": "Tatsächlich war es: {truth}",
  "finale.supported": "Ihre Funde trugen diese These.",
  "finale.unsupported": "Ihre eigenen Funde sprachen dagegen.",
  "finale.collected": "{collected} von {total} Hinweisen gesichert.",
  "finale.restart": "Neuer Durchlauf",
  "briefing.forecast.uncertain": "{tier}, evtl. {alternative}",
  "map.hud.forecast.uncertain": "{tier}?",
  "briefing.detour": "Kurs führt {percent} % Umweg um Untiefen — {miles} sm über Grund.",
  "menu.sound": "Ton",
  "menu.sound.on": "An",
  "menu.sound.off": "Aus",
  "menu.imprint": "Impressum",
  "imprint.title": "Impressum & Hinweise",
  "imprint.ai.heading": "Einsatz künstlicher Intelligenz",
  "imprint.ai.body": "Dieses Spiel wurde vollständig mit Unterstützung generativer KI entwickelt — Programmcode, Texte, Spielmechanik und Klanggestaltung entstanden in Zusammenarbeit mit Claude (Anthropic).\n\nEs kommen keine KI-generierten Bilder und keine Audiodateien zum Einsatz. Karte und Oberfläche werden zur Laufzeit aus dem Programmcode gezeichnet, aller Klang im Browser synthetisiert. Die Fotografien — Porträts, Schiffe, Flugzeuge, Einsatzorte — sind reale Aufnahmen aus gemeinfreien Archiven und einer Stockfoto-Plattform; Nachweise im vollständigen Impressum. Die Hinweistexte des Spiels sind erfunden und beschreiben keine tatsächlichen Ereignisse, Personen oder Fahrzeuge.",
  "imprint.privacy.heading": "Datenschutz",
  "imprint.privacy.body": "Das Spiel läuft vollständig im Browser. Kein Server, keine Konten, keine Cookies. Die Nutzung wird mit einem selbst betriebenen Matomo gezählt — ohne Cookies, mit gekürzter IP-Adresse, „Do Not Track“ wird befolgt. Widerspruch jederzeit unter Einstellungen → Reichweitenmessung oder in der Datenschutzerklärung. Im lokalen Speicher liegen ausschließlich Spielstand, Sprache, Schriftgröße, Ton-Einstellung und ein etwaiger Widerspruch; sie verlassen das Gerät nicht.",
  "imprint.data.heading": "Kartendaten",
  "imprint.data.body": "Bathymetrie: ETOPO 2022, NOAA National Centers for Environmental Information (gemeinfrei). Küstenlinien: Natural Earth (gemeinfrei). Die Karte ist ein Spielgegenstand und nicht zur Navigation geeignet.",
  "imprint.legal.hint": "Vollständige Anbieterkennzeichnung und Datenschutzerklärung: impressum.html",
  "imprint.version": "Version {version}",
  "imprint.close": "Zurück"
}
